export default function resetRowIndexes(repeater) {
	const rows = repeater.querySelectorAll('.row')
	let i = 0

	rows.forEach(row => {
		row.querySelector('.row-number').innerText = i + 1

		const inputs = row.querySelectorAll('[name^="attr:"]')

		inputs.forEach(input => {
			const name = input.name

			input.name = name.replace(/(attr:\d+)\[(-?\d+)\]/g, function (match, p2) {
				return p2 + '[' + i + ']'
			})
		})

		i++
	})
}
